module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"chooseSpeciality":"აირჩიე სპეციალობა","loadMore":"მეტის ჩატვირთვა","returnToInterview":"ინტერვიუზე დაბრუნება","orFillOutQuestionnaire":"ან შეავსე კითხვარი"},"en":{"chooseSpeciality":"Choose Speciality","loadMore":"Load More","returnToInterview":"Return to Interview","orFillOutQuestionnaire":"Or fill out Questionnaire"}}')
  delete Component.options._Ctor
}
